import { createStore, useStore } from '../../state/createStore';
import { TOAST_DURATION_MS } from '../tokens';
import { Icon } from './Icon';

// Toast (05 / 06 "Saved to Report Draft"): bottom pill, auto-dismiss 2.5s, never blocks input.
// success = primary ground + ✓; info = inverse surface (the AI notice slot, §16.5).
export interface ToastItem {
  id: number;
  kind: 'success' | 'info';
  text: string;
}

export const toastStore = createStore<{ toasts: ToastItem[] }>({ toasts: [] });

let nextToastId = 1;

export function showToast(text: string, kind: ToastItem['kind'] = 'success', durationMs: number = TOAST_DURATION_MS): number {
  const id = nextToastId++;
  toastStore.set((prev) => ({ toasts: [...prev.toasts, { id, kind, text }] }));
  setTimeout(() => dismissToast(id), durationMs);
  return id;
}

export function dismissToast(id: number): void {
  toastStore.set((prev) => (prev.toasts.some((t) => t.id === id) ? { toasts: prev.toasts.filter((t) => t.id !== id) } : prev));
}

export function resetToastsForTests(): void {
  toastStore.set(() => ({ toasts: [] }));
}

export function ToastHost() {
  const toasts = useStore(toastStore, (s) => s.toasts);
  if (toasts.length === 0) return null;
  return (
    <div className="toast-host" aria-live="polite" data-testid="toast-host">
      {toasts.map((toast) => (
        <div key={toast.id} className={`toast toast-${toast.kind}`} role="status" data-testid="toast">
          {toast.kind === 'success' ? <Icon name="check_circle" size={20} /> : <Icon name="info" size={20} />}
          <span>{toast.text}</span>
        </div>
      ))}
    </div>
  );
}
